import { render, staticRenderFns } from "./bottomMenu.vue?vue&type=template&id=4b546078&scoped=true&"
import script from "./bottomMenu.vue?vue&type=script&lang=js&"
export * from "./bottomMenu.vue?vue&type=script&lang=js&"
import style0 from "./bottomMenu.vue?vue&type=style&index=0&id=4b546078&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b546078",
  null
  
)

export default component.exports